import React, { Component } from 'react';
// Externals
import classNames from 'classnames';
import PropTypes from 'prop-types';
// Material helpers
import { withStyles } from '@material-ui/core/styles';
// Shared components
import PortletContent from 'components/PortletContent';
import { Grid } from '@material-ui/core';
import Loading from '../../../../../utils/Loading'
// Component styles
import styles from './styles';
import moment from 'moment'
import 'moment/locale/es'
import { Typography } from '@material-ui/core';
moment.locale('es')
const api_host_legacy = process.env.REACT_APP_API_LEGACY
const api_host = process.env.REACT_APP_API

class ReportLegacy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      parentObj: this.props.parentObj,
      obj: this.props.obj,
      isLoad: true,
      isLoad2: true,
      report: this.props.report,
      horario_id: this.props.horario_id,
      nameSchedule: this.props.nombre_horario,
      scheduleBoolean: this.props.scheduleBoolean,
      periodBoolean: this.props.periodBoolean,
      namePeriod: this.props.namePeriod,
      reportBoolean: this.props.reportBoolean,
      listReport: this.props.listReport,
      indexReport: this.props.indexReport,
      period: this.props.period,
      state: this.props.state,
      loadPdf: false,
      objButton: this.props.objButton,
      pdf: this.props.pdf,
      listObjetivesTypeOne: [62239, 62398, 58116, 58120, 62016]
    }
  }

  componentDidMount() {
    this.getSpecial()
  }

  static getDerivedStateFromProps(props, state) {
    if (typeof (props.obj) !== "undefined") {
      if (props.obj.id !== state.obj.id) {
        return {
          isLoad2: true,
          isLoad: true,
          obj: props.obj,
          report: props.report
        }
      }
    }

    if (props.horario_id !== state.horario_id) {
      return {
        isLoad: true,
        horario_id: props.horario_id,
        report: props.report,
        isLoad2: true,
      }
    }
    if (props.namePeriod !== state.namePeriod) {
      return {
        isLoad: true,
        namePeriod: props.namePeriod,
        report: props.report,
        isLoad2: true,
        period: props.period,
        state: props.state
      }
    }
    if (props.indexReport !== state.indexReport || props.report !== state.report) {
      return {
        isLoad: true,
        indexReport: props.indexReport,
        listReport: props.listReport,
        isLoad2: true,
        report: props.report,
      }
    }
    return null;
  }
  componentDidUpdate(prevProps, prevState) {
    if (typeof (prevProps.obj) !== "undefined") {
      if (prevProps.obj.id !== this.state.obj.id) {
        this.getSpecial();
      }
    }
    if (prevProps.horario_id !== this.state.horario_id || prevProps.namePeriod !== this.state.namePeriod
      || prevProps.indexReport !== this.state.indexReport || prevProps.report !== this.state.report) {
      this.getSpecial();
    }
  }

  getSpecial = () => {
    const { obj, parentObj, isLoad2, scheduleBoolean, periodBoolean, horario_id,
      reportBoolean, listReport, objButton, period, state, listObjetivesTypeOne } = this.state
    const user = sessionStorage.getItem('user')
    var type = 0
    if (listObjetivesTypeOne.includes(parentObj)) {
      type = 1
    }
    var url = api_host_legacy + "/acceso_especial.php?acceso_pdftohtml=1&es_pdf=true&type=" + type + "&es_especial=1&tiene_svg=1"
    var final = moment()
    var begin = moment().subtract({ "days": 1 })
    if (periodBoolean === true) {
      if (period === "3d") {
        begin = moment().subtract({ "days": 3 })
      }
      if (period === "w") {
        begin = moment().subtract({ "days": 7 })
      }
      if (period === "c") {
        begin = moment(state.startDate)
        final = moment(state.endDate).add({ 'days': 1 })
      }
      url += "&fecha_inicio=" + String(begin.format("YYYY-MM-DD") + " 00:00:00") + "&fecha_termino=" + String(final.format("YYYY-MM-DD") + " 00:00:00")
    }
    if (scheduleBoolean === true) {
      url += "&horario_id=" + horario_id
    }
    if (reportBoolean === true) {
      if (parseInt(listReport.dia_termino) > moment().day() && parseInt(listReport.dia_inicio) < moment().day()) {
        begin = begin.set({ "day": parseInt(listReport.dia_inicio) })
        final = final.set({ "day": parseInt(listReport.dia_termino) })
      } else {
        begin = begin.subtract({ "months": 1 }).format("YYYY-MM") + "-" + listReport.dia_inicio + " 00:00:00"
        if (listReport.dia_termino === "01") {
          final = final.subtract({ "months": 1 }).endOf('month').add(1, 'days').format("YYYY-MM-DD") + " 00:00:00"
        } else {
          final = final.subtract({ "months": 1 }).format("YYYY-MM") + "-" + listReport.dia_termino + " 00:00:00"
        }
      }
      url += "&fecha_inicio=" + begin + "&fecha_termino=" + final
    }
    if (objButton === true) {
      url += "&subobjetivo_id=" + obj.id
    }
    url += "&objetivo_id=" + parentObj + "&usuario_id=" + user
    //console.log(url)
    var data = <object style={{ height: "800px", width: "100%" }} type="text/html" data={url}></object>
    this.setState({
      isLoad: false,
      data: data
    });
    setTimeout(() => this.setState({
      isLoad2: false
    }), 10000);
  }


  render() {
    const { obj, isLoad, page, data, isLoad2, loadPdf, objButton, pdf } = this.state

    if (isLoad === true) {
      return (
        <PortletContent style={{ height: "100%" }}>
          <Loading />
        </PortletContent>
      )
    } else {
      var display = "hidden"
      var load = ""
      if (isLoad2 === false) {
        display = ""
        load = "hidden"
      }
      return (
        <PortletContent style={{ height: "100%" }}>
          <Grid
            container
            spacing={1}
            //style={{visibility:load}}
            justify="center"
          >
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              xl={6}
              style={{ textAlign: "center" }}
            >
              {isLoad2 ? <Loading text={"Espere un momento por favor..."} />
                : <div>
                  <Typography variant="h5" style={{ color: '#66788A' }}>Archivo generado</Typography>
                  <Typography variant="h5" style={{ color: '#66788A' }}>Espere un momento que se descargue</Typography>
                  <div style={{ height: '1px' }}>{data}</div>
                </div>}
            </Grid>
          </Grid>
        </PortletContent>
      )
    }
  }
}

ReportLegacy.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ReportLegacy);
